import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import get from 'lodash/get';
// Components
import OMTitle from '../../components/OMComponents/OMTitle/OMTitle';
import PackageTitleForPayment from '../../components/PackageTitleForPayment/PackageTitleForPayment';
import HighlightTitleForPublisherPackage from '../../components/HighlightTitleForPublisherPackage/HighlightTitleForPublisherPackage';
import OMSubmitButton from '../../components/OMComponents/OMSubmitButton/OMSubmitButton';
import DetailsToInvoiceInputField from './DetailsToInvoiceInputField';
// Helpers
import { calculatePaymentAmountWithVatForRequest, calculatePriceWithDiscount } from '../../helpers/paymentCalculation';
import beautifyNumber from '../../helpers/beautifyNumber';
import clearNumber from '../../helpers/clearNumber';
import { israelCardholderId, required } from '../../helpers/reduxFormValidators';
// Styles
import styles from './DetailsToInvoiceForm.scss';
import { packageTypes, periods } from '../../packagesData';

class DetailsToInvoiceForm extends Component {
  state = {
    showPreloader: false
  };

  componentDidMount() {
    if (!this.props.isMobile) {
      document.body.style.overflow = 'hidden';
    }
  }

  componentWillUnmount() {
    if (!this.props.isMobile) {
      document.body.style.overflow = '';
    }
  }

  renderPrice = price => `₪${beautifyNumber(clearNumber(price))} / ${this.props.translate('month')}`;

  renderIdField = () => {
    const { translate, isAgent } = this.props;
    const validateFunc = (isAgent) ? required : israelCardholderId;
    const translationPrefix = (isAgent) ? 'companyId' : 'id';

    return (
      <Field
        name="tax_id"
        component={DetailsToInvoiceInputField}
        errorMsg={`${translate(`${translationPrefix}ErrorMessage`)}`}
        iconName="id-card"
        validate={[validateFunc]}
        placeholder={translate(translationPrefix).toString()}
      />
    );
  };

  renderPublisherTitle = () => {
    const { selectedPackage, isAgent } = this.props;
    const { period, alternativePeriod } = selectedPackage;
    const currentPeriod = get(this.props.currentPackageData, `period.${period}`) ? period : alternativePeriod;

    const price = calculatePriceWithDiscount(this.props.currentPackageData, currentPeriod);

    const { highlight, autojump, top } = get(this.props, `currentPackageData.period[${currentPeriod}]`) || {};
    const type = get(this.props, 'currentPackageData.type');

    return (
      <PackageTitleForPayment
        properties={(<span className={styles.boldText}>{this.props.translate(`${type}Ad`)}</span>)}
        highlight={(
          <HighlightTitleForPublisherPackage
            haveHighlight={highlight}
            haveAutojump={autojump}
            haveTopPromotion={top}
            topPromotionLabel={`${this.props.translate('topPromotionLabel')}`}
          />
        )}
        // price={`₪${beautifyNumber(clearNumber(price))}`}
        isAgent={isAgent}
      />
    );
  };

  renderRealtorTitle = () => {
    const { isAgent } = this.props;
    const propertiesCount = get(this.props, 'currentPackageData.properties');

    return (
      <PackageTitleForPayment
        properties={(<span className={styles.boldText}>{`${this.props.translate('plan')} ${propertiesCount}`}</span>)}
        isAgent={isAgent}
      />
    );
  };

  renderLeadsTitle = () => {
    const { isAgent, selectedPackage } = this.props;
    const { period } = selectedPackage;
    const leadsCount = get(this.props, `currentPackageData.period.${period}.quantity`);

    return (
      <PackageTitleForPayment
        properties={(<span className={styles.boldText}>
          {`${leadsCount} ${this.props.translate(leadsCount === 1 ? 'lead' : 'leads')}`}
        </span>)}
        isAgent={isAgent}
      />
    );
  };

  renderRocketTitle = () => {
    const { isAgent } = this.props;
    const perions = get(this.props, 'currentPackageData.periods');

    return (
      <PackageTitleForPayment
        properties={(<span className={styles.boldText}>{`${this.props.translate('plan')} ${perions}`}</span>)}
        isAgent={isAgent}
      />
    );
  }

  renderTitle = () => {
    const { isAgent } = this.props;
    const packageType = get(this.props, 'currentPackageData.type');

    switch (packageType) {
      case packageTypes.LEADS:
        return this.renderLeadsTitle();
      case packageTypes.ROCKET:
        return this.renderRocketTitle();
      default:
        return isAgent ? this.renderRealtorTitle() : this.renderPublisherTitle();
      }
  }

  render() {
    const { translate, selectedPackage, isAgent } = this.props;
    const { period, alternativePeriod } = selectedPackage;
    const currentPeriod = get(this.props.currentPackageData, `period.${period}`) ? period : alternativePeriod;
    const packageType = get(this.props, 'currentPackageData.type');

    const couponType = get(this.props, 'discountCoupon.type');
    const { priceGrand } = calculatePaymentAmountWithVatForRequest(selectedPackage, this.props.packages, couponType);

    const timeUnits = isAgent ? 'months' : 'days';

    return (
      <div className={styles.invoiceWrapper}>
        <div className={styles.headerWrapper}>
          <OMTitle
            className="publishTitle"
            title={translate('purchaseSummary')}
          />

          {this.renderTitle()}

          <div className={styles.totalBlock}>
            {period !== periods.FOREVER &&
              <div>
                {translate((isAgent) ? 'advertisingFor' : 'promotionFor')}&nbsp;
                {currentPeriod}&nbsp;
                {translate((packageType === packageTypes.ROCKET) ? 'days' : timeUnits)}
              </div>
            }
            <div>
              {translate('totalInclude')}₪{priceGrand}
            </div>
          </div>
        </div>
        <div className={styles.formWrapper}>
          <OMTitle
            className="publishTitle"
            title={translate('detailsToInvoice')}
          />
          <form
            onSubmit={this.props.handleSubmit((data) => {
              this.setState({ showPreloader: true });
              this.props.onSubmit(data);
            })}
          >
            <Field
              name="invoice_name"
              component={DetailsToInvoiceInputField}
              errorMsg={`${translate('nameErrorMessage')}`}
              iconName="user"
              validate={[required]}
              placeholder={translate('nameForInvoice').toString()}
            />
            {this.renderIdField()}
            <OMSubmitButton
              title={translate('continuePay')}
              activeSpinner={this.state.showPreloader}
              disabled={this.state.showPreloader}
            />
          </form>
        </div>
      </div>
    );
  }
}

DetailsToInvoiceForm.propTypes = {
  selectedPackage: PropTypes.object,
  currentPackageData: PropTypes.object,
  discountCoupon: PropTypes.object,
  packages: PropTypes.array,
  translate: PropTypes.func,
  isMobile: PropTypes.bool,
  isAgent: PropTypes.bool,
  handleSubmit: PropTypes.func,
  onSubmit: PropTypes.func
};

export default reduxForm({
  form: 'details-to-invoice'
})(DetailsToInvoiceForm);
